// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__JlzJ8","fullHeight":"styles_fullHeight__y_9nF","titleContainer":"styles_titleContainer__WyMxW","title":"styles_title__yznT0"};